import React from "react";

const DownloadOutReachCSV = () => {
  const handleDownload = () => {
    const csvUrl = "/outreach-csv.csv";
    const link = document.createElement("a");
    link.href = csvUrl;
    link.download = "sample_outreach-csv.csv";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <button
      className='bg-red-600 px-3 py-1 rounded text-white'
      color=''
      onClick={handleDownload}
    >
      Download CSV
    </button>
  );
};

export default DownloadOutReachCSV;
